import { useMemo } from "react";
import {
    getAreaListThunk,
    getKpiGetProgressThunk,
    getKpiGetSalaryToPayThunk,
} from "tm-shared/api";
import { warmupImages } from "tm-shared/utils";

import {
    useAppDispatch,
    useAppSelector,
    useProtectedUserRoleSelector,
} from "@/hooks/redux";
import { getCatalogProductsThunk } from "@/store/slices/catalog";
import { getFileUrl, getKpiTargetDate } from "@/utils";

type InitRetryCommand = {
    title: string;
    run: () => Promise<unknown>;
};

export const useInitRetryRequests = () => {
    const dispatch = useAppDispatch();

    const role = useProtectedUserRoleSelector();
    const employee = useAppSelector((s) => s.user.employee);

    return useMemo<Partial<Record<string, InitRetryCommand>>>(() => {
        const kpiTargetDate = getKpiTargetDate();

        let result: Partial<Record<string, InitRetryCommand>> = {
            getAreaListThunk: {
                title: "Отримання доступних регіонів",
                run: () => dispatch(getAreaListThunk()).unwrap(),
            },
            getCatalogExportThunk: {
                title: "Завантаження каталогу",
                run: async () => {
                    const productsMap = await dispatch(
                        getCatalogProductsThunk(),
                    ).unwrap();

                    const imageUrls = Object.values(productsMap)
                        .map((p) => p.params.image.value.map(getFileUrl))
                        .flat();
                    warmupImages(imageUrls);
                },
            },
        };

        if (employee) {
            const commonKpiParams = {
                employeeId: employee.id,
                targetDate: kpiTargetDate,
                roleSlug: role,
            };

            result = {
                ...result,
                getKpiGetSalaryToPayThunk: {
                    title: "Завантаження зарплати",
                    run: () =>
                        dispatch(
                            getKpiGetSalaryToPayThunk(commonKpiParams),
                        ).unwrap(),
                },
                getKpiGetProgressThunk: {
                    title: "Завантаження прогресу KPI",
                    run: () =>
                        dispatch(
                            getKpiGetProgressThunk(commonKpiParams),
                        ).unwrap(),
                },
            };
        }

        return result;
    }, [dispatch, employee, role]);
};
